class ProductSelector extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init(){
    this.inputWrapper = 'fieldset[data-input-wrapper]';
    this.variants = JSON.parse(
      this.querySelector(`#ProductVariantData-${this.dataset.sectionId}`).textContent
    );
    this.form = document.querySelector(
      `#ProductForm-${this.dataset.sectionId}`
    );
    this.purchaseOptions = document.querySelector(
      `#Product-Purchase-Options-${this.dataset.sectionId}`
    );
    this.productBar = document.querySelector(
      `#ProductBar-${this.dataset.sectionId}`
    );
    this.installmentsForm = document.querySelector(
      `${this.dataset.installmentsFormId}` // check: `${this.dataset.installmentsFormId}`
    );
    this.addEventListener('change', this.onVariantChange);
    this.updateOptions();
    this.updateVariantStatuses();
    this.updateVariant();
    this.updateVariantInput();
    // if (typeof this.form.toggleAddButton == 'function') {
    //   this.form.toggleAddButton(!this.currentVariant.available, '');
    // }
  }

  updateVariantStatuses() {
  const inputWrappers = [
    ...this.querySelectorAll('fieldset[data-input-wrapper]')
  ];

  const selectedValues = inputWrappers.map(wrapper => {
    const checked = wrapper.querySelector('input[type="radio"]:checked');
    return checked ? checked.value : null;
  });

  inputWrappers.forEach((option, index) => {
    if (index === 0) return;

    const optionInputs = [
      ...option.querySelectorAll('input[type="radio"], option')
    ];

    optionInputs.forEach(input => {
      const testValue = input.getAttribute('value');

      // Build a test selection substituting this input's value at current index
      const testValues = [...selectedValues];
      testValues[index] = testValue;

      // Check if any available variant matches upstream options (downstream options are wildcards)
      const hasAvailableVariant = this.variants.some(variant => {
        return variant.available &&
          testValues.every((val, i) => {
            if (val === null) return true;
            if (i > index) return true;
            return variant[`option${i + 1}`] === val;
          });
      });

      const inputIsDisabled = !hasAvailableVariant;

      input.disabled = inputIsDisabled;
      if (input.tagName.toLowerCase() === 'option') {
        input
          .closest('dropdown-input')
          ?.querySelector(`button[data-value="${input.value}"]`)
          ?.toggleAttribute('disabled', inputIsDisabled);
      }
      if (!this.productBar) return;
      const inputId = input.dataset.id || input.id;
      const productBarInput = this.productBar.querySelector(
        `option[data-id="${inputId}"]`
      );
      if (!productBarInput) return;
      productBarInput.disabled = inputIsDisabled;
    });
  });
}

  onVariantChange(event) {
    if (event.target.getAttribute('name') === 'options[Shape]') {
      document.querySelector('.shape-text').textContent = event.target.value
    }
    if (event.target.type === 'number') return;
    this.updateOptions();
    this.autoSelectForChangedOption(event.target);
    if (this.currentVariant === this.getVariantData()) return;

    //this.productBarUpdateOptions();
    this.updateVariant();
    this.updateVariantStatuses();
    this.updatePickupAvailability();
    // this.form.removeAttribute('data-has-selling-plan');
    // this.form.toggleAddButton(false, '');
    // this.form.handleErrorMessage();

    if (!this.currentVariant) {
      // this.form.toggleAddButton(true, '');
      this.setUnavailable();

      return;
    }

    if (!this.currentVariant.available) {
      ``;
      // this.form.toggleAddButton(true, window.variantStrings.soldOut);
    }

    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();

  }

  autoSelectForChangedOption(target) {
    const fieldsets = [...this.querySelectorAll('fieldset[data-input-wrapper]')];
    const changedFieldset = target.closest('fieldset[data-input-wrapper]');
    const changedIndex = fieldsets.indexOf(changedFieldset);
    if (changedIndex < 0) return;

    const currentVariant = this.getVariantData();
    if (currentVariant && currentVariant.available) return;

    // Find first available variant that matches all selected options up to and including the changed one
    const availableVariant = this.variants.find(variant => {
      if (!variant.available) return false;
      return this.options.slice(0, changedIndex + 1).every((opt, i) =>
        variant[`option${i + 1}`] === opt.value
      );
    });

    if (!availableVariant) return;

    // Update downstream options to match the available variant
    fieldsets.forEach((fieldset, i) => {
      if (i <= changedIndex) return;
      const newValue = availableVariant[`option${i + 1}`];

      const radios = fieldset.querySelectorAll('input[type="radio"]');
      if (radios.length) {
        radios.forEach(radio => { radio.checked = radio.value === newValue; });
        return;
      }

      const select = fieldset.querySelector('select');
      if (select) {
        select.value = newValue;
        Array.from(select.options).forEach(opt => { opt.selected = opt.value === newValue; });
        fieldset.querySelector('dropdown-input')?.update();
      }
    });

    this.updateOptions();
  }

  updateOptions() {
  this.querySelectorAll('input[type="radio"]').forEach(input => {
    input.nextElementSibling.classList.toggle(
      'is-active',
      input.checked
    );
  });
  this.options = Array.from(
    this.querySelectorAll('fieldset[data-input-wrapper]'),
    fieldset => {
      const checked = fieldset.querySelector('input[type="radio"]:checked');
      const select = fieldset.querySelector('select');
      const el = checked || select;
      if (!el) return null;
      return { name: el.dataset.name || el.name, value: el.value };
    }
  ).filter(Boolean);
}

  productBarUpdateOptions() {
    Array.from(this.productBar.querySelectorAll('select')).map(
      selector => {
        selector.value = this.options.find(
          option => option.name === selector.name
        ).value;
      }
    );
  }

  updateInventoryNotice(html) {
    const destination = document.querySelector('[data-inventory-notice]');
    const source = html.querySelector('[data-inventory-notice]');

    if (source && destination) destination.innerHTML = source.innerHTML;
  }

  updatePickupAvailability() {
    const pickUpAvailabilityNode = document.querySelector(
      'pickup-availability'
    );

    if (!pickUpAvailabilityNode || !this.currentVariant) return;

    pickUpAvailabilityNode.dataset.variantId = this.currentVariant.id;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailabilityNode.setAttribute('available', '');
      pickUpAvailabilityNode.fetchAvailability(
        pickUpAvailabilityNode.dataset.variantId
      );

      return;
    }

    pickUpAvailabilityNode.removeAttribute('available');
    pickUpAvailabilityNode.innerHTML = '';
  }

  updateVariant() {
    this.currentVariant = this.getVariantData();
  }

  getVariantData() {
    return this.options.length
      ? this.variants.find(variant => {
          return !variant.options
            .map(
              (option, index) => this.options[index].value === option
            )
            .includes(false);
        })
      : this.variants[0];
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media)
      return;

    const productMedia = document.querySelector('product-media');
    productMedia.setActiveMedia(
      this.currentVariant.featured_media.id
    );
  }

  updateURL(sellingPlanId) {
    if (!this.currentVariant) return;
    const params = new URLSearchParams(window.location.search);
    params[params.has('variant') ? 'set' : 'append'](
      'variant',
      this.currentVariant.id
    );
    if (sellingPlanId) {
      params[params.has('selling_plan') ? 'set' : 'append'](
        'selling_plan',
        sellingPlanId
      );
    } else {
      params.delete('selling_plan');
    }
    const cleanBase = this.dataset.url.split('?')[0];
window.history.replaceState(
  {},
  '',
  `${cleanBase}?${params.toString()}`
);
  }

  updateVariantInput() {
    const inputs = [
      this.querySelector('[name="id"]'),
      this.installmentsForm?.querySelector('[name="id"]')
    ];
    inputs.forEach(input => {
      if (!input) return;
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    //Enavi Custom event for variant change
    document.dispatchEvent(new CustomEvent('enavi:variantChange', {
      detail: { 
        variant: this.currentVariant 
      } 
    }));
if(window.BOLD && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function'){
  BOLD.common.eventEmitter.emit('BOLD_COMMON_variant_changed', { variant: this.currentVariant });
}
  }

  setUnavailable() {
    const submitButton = this.form.submitButton;
    const price = this.querySelector(
      `#Product-Price-${this.dataset.sectionId}`
    );

    if (!submitButton) return;
    submitButton.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  renderProductInfo() {
    const params = new URLSearchParams(window.location.search);
    params[params.has('variant') ? 'set' : 'append'](
      'variant',
      this.currentVariant.id
    );
    params.append('section_id', this.dataset.sectionId);

    fetch(`${this.dataset.url.split('?')[0]}?${params.toString()}`)
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(
          responseText,
          'text/html'
        );
        this.updateInventoryNotice(html);

        [
          `#Product-Price-${this.dataset.sectionId}`,
          `#Product-Purchase-Options-${this.dataset.sectionId}`,
          `#affirm-price-${this.dataset.sectionId}`
        ].forEach(liveRegionSelector => {
          const destination = document.querySelector(
            liveRegionSelector
          );
          const source = html.querySelector(liveRegionSelector);

          if (destination && source) {
            destination.classList.remove('visibility-hidden');

            /* Affirm line: do NOT swap in the server's empty <p> (that blanks the line
               until Affirm redraws it). Keep the existing text and only update the
               amount; ljAffirmRefresh() below makes Affirm re-render it. */
            if (liveRegionSelector.indexOf('#affirm-price-') === 0) {
              const liveAffirm = destination.querySelector('.affirm-as-low-as');
              const newAffirm = source.querySelector('.affirm-as-low-as');
              if (liveAffirm && newAffirm && liveAffirm.children.length) {
                liveAffirm.setAttribute(
                  'data-amount',
                  newAffirm.getAttribute('data-amount')
                );
                return;
              }
            }

            destination.innerHTML = source.innerHTML;
          }
        });

        /* INP fix (2026-07-17): refresh Affirm ONCE after the price/purchase
           regions are updated, debounced + deferred, instead of up to 3×
           synchronously inside the loop above. */
        if (typeof window.ljAffirmRefresh === 'function') {
          window.ljAffirmRefresh();
        } else if (window.affirm && window.affirm.ui) {
          window.affirm.ui.refresh();
        }
      });
  }
}

customElements.define('product-selector', ProductSelector);
